import { render, staticRenderFns } from "./SpecimenEvidenceModal.vue?vue&type=template&id=586fdcae"
import script from "./SpecimenEvidenceModal.vue?vue&type=script&lang=js"
export * from "./SpecimenEvidenceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports